import Modal from '../Modal';

interface LogoutModalProps {
  isOpen: boolean;
  closeModal: () => void;
  handleLogout: () => void;
  loading: boolean;
}

const LogoutModal = ({
  closeModal,
  handleLogout,
  isOpen,
  loading,
}: LogoutModalProps) => {
  return (
    <Modal isOpen={isOpen}>
      <div className="m-4">
        <h2 className="text-lg font-semibold mb-4">Do you want to logout?</h2>
        <div className="flex justify-end gap-4">
          <button
            onClick={closeModal}
            className={`px-4 py-2 bg-gray-200 rounded ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleLogout}
            className={`px-4 py-2 bg-red-600 text-white rounded ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={loading}
          >
            {loading ? `Logging out...` : `Yes, Logout`}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
